'use client'

import { useEffect } from 'react'
import { applyPhiMaskDomToElement } from '@/components/PhiMask/phiMaskDom'

const HEAD_METADATA_SELECTORS = [
  'meta[property="og:title"]',
  'meta[property="og:site_name"]',
  'meta[name="twitter:title"]',
] as const

function maskHeadMetadataNodes(): void {
  if (typeof document === 'undefined') return
  for (const selector of HEAD_METADATA_SELECTORS) {
    document.querySelectorAll(selector).forEach((el) => applyPhiMaskDomToElement(el))
  }
}

/**
 * Next.js `generateMetadata` cannot render `PhiMask`; this client effect applies
 * the same `translate="no"` / `ph-no-capture` attributes to head tags that include tenant
 * branding (title template, Open Graph, etc.).
 */
export function PhiMaskDocumentMetadata() {
  useEffect(() => {
    maskHeadMetadataNodes()
    const observer = new MutationObserver(() => maskHeadMetadataNodes())
    observer.observe(document.head, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [])

  return null
}
